import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useRef, useEffect } from 'react';
import AddCropMaster from '../components/AddCropMaster';
import { getCropsNew, getCropById } from '../lib/api';
import { EncryptFE } from '../lib/encrypt';
import { toast } from 'react-toastify';

const customStyles = `
  .tooltip-menu {
    min-width: 140px;
    padding: 0.5rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background: #fff;
    z-index: 1000;
  }
  .tooltip-item {
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-size: 0.875rem;
    color: #4a4a4a;
  }
  .tooltip-item:hover {
    background-color: #f1f5f9;
    color: #1a73e8;
  }
  .customs-select {
    all: unset;
    box-sizing: border-box;
    word-wrap: normal;
    cursor: pointer;
    vertical-align: middle;
    font: inherit;
    background: transparent;
    margin: 0;
    text-align: inherit;
    text-transform: inherit;
    display: block;
    width: 100%;
    font-weight: 400;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    color: var(--text-primary-light) !important;
    background-color: var(--white);
    padding: 0.5625rem 1.875rem 0.5625rem 0.9375rem;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='currentColor' class='bi bi-chevron-down' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 14px;
    padding-right: 20px;
    padding-left: 8px;
    line-height: 22px;
    min-width: 70px;
    max-width: 70px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    height: 40px;
    font-size: 0.875rem;
  }
  .add-crop-master .form-grid-container {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 1.5rem !important;
    width: 100% !important;
    margin-bottom: 1.25rem !important;
  }
  .add-crop-master .form-grid-container > div { 
    width: 100% !important; 
    box-sizing: border-box !important; 
  }
  .add-crop-master .form-control {
    width: 100% !important; 
    box-sizing: border-box !important; 
    border-radius: 8px !important;
    padding: 8px 12px !important; 
    border: 1px solid #ced4da !important; 
    background: #fff !important;
    font-size: 0.875rem !important; 
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  }
  .add-crop-master textarea {
    width: 100% !important; 
    box-sizing: border-box !important; 
    border-radius: 8px !important;
    padding: 8px 12px !important; 
    border: 1px solid #ced4da !important; 
    background: #fff !important;
    font-size: 0.875rem !important; 
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    height: 120px !important; 
    resize: vertical !important;
  }
  .add-crop-master select {
    width: 100% !important; 
    box-sizing: border-box !important; 
    border-radius: 8px !important; 
    padding: 8px 24px 8px 12px !important;
    border: 1px solid #ced4da !important; 
    background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='%23333' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E") no-repeat right 0.75rem center !important;
    background-size: 14px !important; 
    font-size: 0.875rem !important; 
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    appearance: none !important; 
    -webkit-appearance: none !important; 
    -moz-appearance: none !important;
  }
  .add-crop-master .form-control:focus,
  .add-crop-master textarea:focus,
  .add-crop-master select:focus { 
    border-color: #1a73e8 !important; 
    box-shadow: 0 0 0 0.2rem rgba(26, 115, 232, 0.25) !important; 
    outline: none !important; 
  }
  .add-crop-master .error-message { 
    color: #dc3545; 
    font-size: 0.75rem; 
    margin-top: 0.25rem; 
  }
  .add-crop-master .success-message { 
    color: #28a745; 
    font-size: 0.875rem; 
    margin-bottom: 1rem; 
    text-align: center; 
  }
  .add-crop-master .section { 
    border: 1px solid #e2e8f0; 
    border-radius: 8px; 
    padding: 1.5rem; 
    margin-bottom: 1.5rem; 
  }
  .add-crop-master .add-button { 
    margin-top: 0.5rem; 
  }
  .add-crop-master .table { 
    border-collapse: collapse; 
    width: 100%; 
    border: 1px solid #ddd; 
    background-color: #fff; 
    box-shadow: 0 2px 4px rgba(0,0,0,0.1); 
    border-radius: 8px; 
    overflow: hidden; 
  }
  .add-crop-master .table th, 
  .add-crop-master .table td { 
    border: 1px solid #ddd; 
    padding: 8px; 
    text-align: left; 
  }
  .add-crop-master .table th { 
    background-color: #126B3A; 
    color: #fff; 
    font-weight: bold; 
  }
  .add-crop-master .table tr:nth-child(even) { 
    background-color: #f9f9f9; 
  }
  .add-crop-master .bullet-list { 
    list-style-type: disc; 
    padding-left: 20px; 
  }
  .add-crop-master .bullet-list li { 
    margin-bottom: 4px; 
  }
  .add-crop-master .form-check { 
    margin-bottom: 0 !important; 
    display: flex !important; 
    align-items: center !important; 
    gap: 8px !important; 
  }
  .add-crop-master .form-check-input[type="checkbox"] {
    appearance: none !important; 
    -webkit-appearance: none !important; 
    width: 16px !important; 
    height: 16px !important;
    border: 2px solid #4a5568 !important; 
    border-radius: 4px !important; 
    display: inline-block !important; 
    position: relative !important; 
    cursor: pointer !important;
    background-color: #fff !important; 
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out !important;
  }
  .add-crop-master .form-check-input[type="checkbox"]:checked {
    background-color: #1a73e8 !important; 
    border-color: #1a73e8 !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3E%3C/svg%3E") !important;
    background-size: 12px !important; 
    background-position: center !important; 
    background-repeat: no-repeat !important;
  }
  .add-crop-master .form-check-input[type="checkbox"]:focus { 
    box-shadow: 0 0 0 0.2rem rgba(26, 115, 232, 0.25) !important; 
    outline: none !important; 
  }
  .add-crop-master .form-check label { 
    font-size: 0.875rem !important; 
    font-weight: 500 !important; 
    color: #4a4a4a !important; 
    margin-bottom: 0 !important; 
    cursor: pointer !important; 
  }
  .add-crop-master .card-body { 
    overflow-y: auto !important; 
    max-height: calc(100vh - 80px) !important; 
    padding: 1.5rem !important; 
    overscroll-behavior: contain !important; 
  }
  .add-crop-master .close-btn { 
    position: absolute !important; 
    top: 1rem !important; 
    right: 1rem !important; 
    z-index: 10 !important; 
  }

  /* Tabs */
  .tabs-row { 
    display: flex; 
    gap: 8px; 
    margin-bottom: 12px; 
    align-items: center; 
    flex-wrap: wrap;
  }
  .main-tab { 
    padding: 8px 14px; 
    border: 1px solid #e5e7eb; 
    background: #f9fafb; 
    border-radius: 8px; 
    cursor: pointer; 
    font-weight: 600;
  }
  .main-tab.active { 
    background: #e8f0fe; 
    border-color: #1a73e8; 
    color: #1a73e8;
  }
  .main-tab:disabled { 
    opacity: 0.6; 
    cursor: not-allowed; 
  }
  .lang-tabs { 
    display: flex; 
    gap: 8px; 
    flex-wrap: wrap; 
    margin-bottom: 12px;
  }
  .lang-tab { 
    padding: 6px 10px; 
    border: 1px solid #e5e7eb; 
    background: #f9fafb; 
    border-radius: 6px; 
    cursor: pointer; 
    font-weight: 500;
  }
  .lang-tab.active { 
    background: #e8f0fe; 
    border-color: #1a73e8; 
    color: #1a73e8;
  }
  .chip { 
    display: inline-block; 
    padding: 4px 8px; 
    border: 1px solid #e5e7eb; 
    background: #f9fafb; 
    border-radius: 6px; 
    font-size: 12px; 
    margin-right: 6px; 
    margin-bottom: 6px;
  }

  /* Image Preview Styles */
  .image-preview-container { 
    margin-top: 12px; 
  }
  .image-preview-title { 
    font-weight: 600; 
    font-size: 0.875rem; 
    margin-bottom: 8px; 
    display: block; 
  }
  .image-preview-grid { 
    display: flex; 
    flex-wrap: wrap; 
    gap: 8px; 
  }
  .image-preview-item { 
    position: relative; 
    border: 1px solid #e2e8f0; 
    border-radius: 6px; 
    padding: 4px; 
  }
  .image-preview { 
    width: 80px; 
    height: 80px; 
    object-fit: cover; 
    border-radius: 4px; 
  }
  .image-remove-btn { 
    position: absolute; 
    top: -6px; 
    right: -6px; 
    background: #dc3545; 
    color: white; 
    border: none; 
    border-radius: 50%; 
    width: 20px; 
    height: 20px; 
    font-size: 12px; 
    cursor: pointer; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
  }
  .small-image-preview { 
    width: 40px; 
    height: 40px; 
    object-fit: cover; 
    border-radius: 4px; 
  }
`;

const CropMasterList = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [crops, setCrops] = useState([]);
    const [cropToEdit, setCropToEdit] = useState(null);
    const [showEntries, setShowEntries] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [editLoading, setEditLoading] = useState(false);
    const [updatingCropId, setUpdatingCropId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const getToken = () => {
        return localStorage.getItem('authToken') || '';
    };

    useEffect(() => {
        console.log(EncryptFE("John"));
        console.log(EncryptFE("Doe"));
        console.log(EncryptFE("roibuquommeze-9146@yopmail.com"));
        console.log(EncryptFE("9876543210"));
        console.log(EncryptFE("Mumbai, India"));
    }, []);

    const fetchCrops = async () => {
        try {
            setLoading(true);
            const token = getToken();
            const response = await getCropsNew(token);
            if (response) {
                setCrops(response);
            }
        } catch (error) {
            console.error('Error fetching crops:', error);
            toast.error('Failed to fetch crops. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCrops();
    }, []);

    const toggleDrawer = async (crop = null) => {
        if (crop) {
            try {
                setEditLoading(true);
                const token = getToken();
                const cropDetails = await getCropById(crop.ID, token);
                
                const transformedCrop = {
                    ...cropDetails,
                    Variants: cropDetails.Variants || [],
                    ID: cropDetails.ID,
                    Category: cropDetails.Category,
                    CropName: cropDetails.CropName,
                    CropShortName: cropDetails.CropShortName,
                    Description: cropDetails.Description,
                    IsActive: cropDetails.IsActive,
                    FeatureImageFileName: cropDetails.FeatureImageFileName,
                    SystemFileName: cropDetails.SystemFileName,
                    AllowedCountries: cropDetails.AllowedCountries,
                    OtherImages: cropDetails.OtherImages || [],
                };
                
                setCropToEdit(transformedCrop);
                setIsDrawerOpen(true);
            } catch (error) {
                console.error('Error fetching crop details for edit:', error);
                toast.error('Failed to load crop details. Please try again.');
                setCropToEdit(crop);
                setIsDrawerOpen(true);
            } finally {
                setEditLoading(false);
            }
        } else {
            setCropToEdit(null);
            setIsDrawerOpen(true);
        }
    };

    // UPDATED: Handle submit without any refresh
    const handleSubmit = async (formData, isUpdate) => {
        if (isSubmitting) return; // Prevent double submission
        
        try {
            setIsSubmitting(true);
            
            if (isUpdate && cropToEdit) {
                // Update the crop in the list without any refresh
                setUpdatingCropId(cropToEdit.ID);
                
                // Fetch the updated crop details
                const token = getToken();
                const updatedCrop = await getCropById(cropToEdit.ID, token);
                
                // Update the crops list with the new data
                setCrops(prevCrops => 
                    prevCrops.map(crop => 
                        crop.ID === cropToEdit.ID 
                            ? {
                                ID: updatedCrop.ID,
                                CropName: updatedCrop.CropName,
                                CropShortName: updatedCrop.CropShortName,
                                Category: updatedCrop.Category,
                                IsActive: updatedCrop.IsActive,
                                NoOfVarieties: updatedCrop.Variants?.length || 0
                              }
                            : crop
                    )
                );
                
                toast.success('Crop updated successfully!');
            } else {
                // For new crop, we need to refresh the list to get the new crop
                await fetchCrops();
                toast.success('Crop added successfully!');
            }
        } catch (error) {
            console.error('Error handling crop submission:', error);
            toast.error('Failed to update crop. Please try again.');
        } finally {
            setIsSubmitting(false);
            setUpdatingCropId(null);
        }
    };

    const filteredCrops = crops.filter(crop => 
        crop.CropName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        crop.CropShortName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        crop.Category?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredCrops.length / showEntries);
    const startIndex = (currentPage - 1) * showEntries;
    const endIndex = startIndex + showEntries;
    const currentCrops = showEntries === -1 ? filteredCrops : filteredCrops.slice(startIndex, endIndex);

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, showEntries]);

    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
            
            if (endPage - startPage + 1 < maxVisiblePages) {
                startPage = Math.max(1, endPage - maxVisiblePages + 1);
            }
            
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
        }
        
        return pages;
    };

    return (
        <>
            <style>{customStyles}</style>
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-nowrap gap-2">
                        <span className="text-sm fw-medium text-secondary-light mb-0">Show</span>
                        <select
                            className="customs-select"
                            value={showEntries}
                            onChange={(e) => setShowEntries(parseInt(e.target.value))}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={-1}>All</option>
                        </select>
                        <div className="relative inline-block">
                            <input 
                                type="text" 
                                className="form-control h-[36px] min-w-[220px] pl-10 pr-3 text-sm border border-neutral-300 radius-6 focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <button
                        onClick={() => toggleDrawer()}
                        className="btn btn-yellow text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                    >
                        <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                        Add New Crop 
                    </button>
                </div>
                <div className="card-body p-24">
                    {loading ? (
                        <div className="text-center py-4">
                            <span>Loading crops...</span>
                        </div>
                    ) : (
                        <>
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Crop Name</th>
                                            <th scope="col">Crop Short Name</th>
                                            <th scope="col">Category</th>
                                            <th scope="col" className="text-center">Is Active</th>
                                            <th scope="col" className="text-center">No. of Varieties</th>
                                            <th scope="col" className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentCrops.map((crop) => (
                                            <tr key={crop.ID}>
                                                <td>
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {crop.CropName}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {crop.CropShortName || '-'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {crop.Category || '-'}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <span
                                                        className={`px-24 py-4 radius-4 fw-medium text-sm ${
                                                            crop.IsActive
                                                                ? 'bg-success-focus text-success-600 border border-success-main'
                                                                : 'bg-neutral-200 text-neutral-600 border border-neutral-400'
                                                        }`}
                                                    >
                                                        {crop.IsActive ? 'Active' : 'Inactive'}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {crop.NoOfVarieties || 0}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex align-items-center gap-10 justify-content-center position-relative">
                                                        <button
                                                            type="button"
                                                            className="edit-btn bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => toggleDrawer(crop)}
                                                            disabled={updatingCropId === crop.ID || editLoading}
                                                        >
                                                            {updatingCropId === crop.ID ? (
                                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            ) : (
                                                                <Icon icon="lucide:edit" className="menu-icon" />
                                                            )}
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {currentCrops.length === 0 && (
                                            <tr>
                                                <td colSpan="6" className="text-center py-4">
                                                    <span className="text-md text-secondary-light">
                                                        {searchTerm ? 'No crops found matching your search.' : 'No crops available.'}
                                                    </span>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            
                            {filteredCrops.length > 0 && showEntries !== -1 && (
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                    <span>
                                        Showing {Math.min(startIndex + 1, filteredCrops.length)} to{' '}
                                        {Math.min(endIndex, filteredCrops.length)} of {filteredCrops.length} entries
                                    </span>
                                    <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                        <li className="page-item">
                                            <button
                                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                                onClick={handlePreviousPage}
                                                disabled={currentPage === 1}
                                            >
                                                <Icon icon="ep:d-arrow-left" className="" />
                                            </button>
                                        </li>
                                        
                                        {getPageNumbers().map(page => (
                                            <li key={page} className="page-item">
                                                <button
                                                    className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${
                                                        currentPage === page ? 'bg-primary-600 text-white' : ''
                                                    }`}
                                                    onClick={() => handlePageChange(page)}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}
                                        
                                        <li className="page-item">
                                            <button
                                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                                onClick={handleNextPage}
                                                disabled={currentPage === totalPages}
                                            >
                                                <Icon icon="ep:d-arrow-right" className="" />
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <AddCropMaster
                isOpen={isDrawerOpen}
                onClose={() => {
                    setCropToEdit(null);
                    setIsDrawerOpen(false);
                }}
                onSubmit={handleSubmit}
                cropToEdit={cropToEdit}
                onCropAdded={() => {}} // Empty function to prevent refresh
            />
        </>
    );
};

export default CropMasterList;